import { ExtraPackageProvider, ExtraPackageType } from '../domain/types/extraPackageType';

export const extraPackageLabels: Record<ExtraPackageType, string> = {
  PHOTO_PLUS: 'Foto plus',
  EXTRA_VISIBILITY: 'Visibilità extra',
  PREMIUM_VISIBILITY: 'Visibilità premium',
  INTERIOR_RESTYLING: 'Restyling interno',
  PRESTIGE: 'Prestige',
  DRONE: 'Drone',
  VERIFICATION_SERVICE: 'Servizio di verifica',
  SPF_APE: 'APE',
  DOCUMENTS_ACCESS: 'Accesso agli atti',
  PERSONALIZED_MARKETING: 'Marketing personalizzato',
  PHOTO_PRO: 'Foto pro',
  INTERIOR_DESIGN: 'Interior design',
  DRONE_VIDEO: 'Video con Drone',
  REFURBISHMENT: 'Progetto di ristrutturazione',
  ENGLISH_VIDEO: 'Video Tour in Inglese',
  URBAN_PLANNING: 'Accesso agli atti',
  BUILDING_REGULARITY: 'Regolarità edilizia',
  APE: 'APE',
  ENERGY_PERFORMANCE_CERTIFICATE: 'APE',
  CASA_OK: 'Casa OK',
  ALL_IN_ONE: 'All in one',
};

export const extraPackageProviderLabels: Record<ExtraPackageProvider, string> = {
  DOVE_IT: 'Dove.it',
  SPF: 'SPF',
};
